<template>
  <b-modal
    title="Resumen por Ubicación"
    ref="modal"
    size="xl"
    lazy
    @shown="getData"
    @hidden="reset"
    hide-footer
  >
    <div
      class="h-100 d-flex justify-content-center align-items-center"
      style="min-height: 400px"
      v-if="isLoading"
    >
      <loading></loading>
    </div>

    <div class="container" v-else>
      <div class="row">
        <div class="col-xl-6 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Capacity</p>
              <h4 class="card-title">105GB</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-6 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Capacity</p>
              <h4 class="card-title">105GB</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Revenue</p>
              <h4 class="card-title">$1,345</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-vector text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Errors</p>
              <h4 class="card-title">23</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-favourite-28 text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Followers</p>
              <h4 class="card-title">+45</h4>
            </div>
          </stats-card>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import StatsCard from "@/components/Cards/StatsCard";

export default {
  name: "ResumenDeAvls",
  components: { StatsCard },
  data: () => ({
    isLoading: true,
  }),
  methods: {
    async getData() {
      setTimeout(() => (this.isLoading = false), 500);
    },
    reset() {
      this.isLoading = true;
    },
  },
};
</script>

<style scoped></style>
